<template>
  <div class="page-wrapper">
    <div class="page layout-page">
      <div class="page-header">
        <header-tool />
        <header-nav />
      </div>
      <div class="page-content">
        <div class="setting-content">
          <!--侧边导航栏-->
          <div class="setting-bar m-r-20">
            <el-menu
              v-if="settingList.length > 0"
              :default-active="settings"
              class="menu"
              @select="handleMenuSelect"
            >
              <template v-for="item in settingList">
                <el-submenu
                  v-if="item.children"
                  :key="item.name"
                  :index="item.name"
                >
                  <template slot="title">{{ item.meta.title }}</template>
                  <el-menu-item
                    v-for="child in item.children"
                    :key="child.name"
                    :index="child.name"
                  >{{ child.meta.title }}</el-menu-item>
                </el-submenu>
                <el-menu-item v-else :key="item.name" :index="item.name">
                  {{ item.meta.title }}
                </el-menu-item>
              </template>
            </el-menu>
          </div>

          <!--匹配的路由内容-->
          <router-view class="router" />
        </div>
      </div>
      <!-- 页脚 -->
      <footer-component class="footer-wrap" />
    </div>
  </div>
</template>

<script>
import FooterComponent from '@/components/LayoutComponent/FooterComponent'
import HeaderTool from '@/components/LayoutComponent/HeaderTool'
import HeaderNav from '@/components/LayoutComponent/HeaderNav'

// 路由数据
import personalCenterRoutes from '@/router/modules/personal-center'
import { mapState } from 'vuex'

export default {
  name: 'PersonalCenter',

  components: {
    FooterComponent,
    HeaderTool,
    HeaderNav
  },

  data() {
    return {
      returnUrl: this.$route.query.returnUrl,
      title: ''
    }
  },

  computed: {
    ...mapState('user', ['loginIdentity']),

    settings() {
      return this.$route.name
    },

    settingList() {
      return personalCenterRoutes[0]?.children.filter(value => {
        let identityBool = true
        if (value.meta?.identity) {
          identityBool = value.meta?.identity.every(el =>
            this.loginIdentity.includes(el)
          )
        }
        return (
          value?.meta?.title &&
          (value.component || value.children) &&
          identityBool
        )
      })
    }
  },

  methods: {
    handleMenuSelect(index) {
      this.$router.push({
        name: index,
        query: {
          returnUrl: this.returnUrl
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  display: flex;
}
.layout-page {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  //justify-content: center;
}

.page-header {
  width: 100%;
}

.page-content {
  flex-grow: 1;
  display: flex;
  margin: 20px 0;
}

.footer-wrap {
  width: 100%;
}

::v-deep .el-dialog__body {
  padding: 0;
  padding-top: 8px;
}

.setting-content {
  display: flex;
  width: 1200px;

  ::v-deep .el-menu {
    height: 100%;
    width: 150px;
    border: none;
    overflow: hidden;

    .menu.el-menu {
      border-radius: 4px;
    }

    .el-menu-item {
      &.is-active {
        color: $primary-color;
        background-color: $primary-third-color;

        &::before {
          content: '';
          display: inline-block;
          width: 2px;
          height: 100%;
          background: $primary-color;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }

    .el-menu-item,
    .el-submenu__title {
      height: 46px;
      line-height: 46px;
    }
    //.el-submenu {
    //  .el-submenu__title {
    //    height: 36px;
    //    line-height: 36px;
    //  }
    //}
  }
}
</style>
